<div class="page-chat content-layout" fxLayout="column">
  <calsoft-page-header
    [height]="'160px'"
    background="url(assets/images/headers/pattern-3.png)"
    [reverse]="true"
  >
  </calsoft-page-header>

  <div class="container" fxFlex fxLayout="column">
    <calsoft-breadcrumbs

      [url]="'product,Bulk Image Upload'"
      [currentPage]="'Product,Bulk Image Upload'"
      [header]="'primary'"
    >
    </calsoft-breadcrumbs>
    <div fxLayout="column" fxLayoutGap="24px">
      <div
        fxLayout="column"
        fxLayout.gt-sm="row"
        fxLayoutAlign.gt-sm="start start"
        fxLayoutGap="24px"
      >
        <div class="card border space" fxFlex="100%" fxFlex.gt-sm>
          <div
            class="header"
            fxLayout="row"
            fxLayoutAlign="space-between center"
          >
            <div class="name" fxLayoutGap="10px" fxLayoutAlign="start center">
              <button [attr.guide]="'image-import-btn-1' + '__' + sanitizedUrl" (click)="back()" matTooltip="Back" mat-icon-button>
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
              Bulk Image Upload
            </div>
          </div>

          <div class="padding-10" fxLayout="column" fxLayoutGap="10px">
            <div class="editSets">
              <div class="title" fxLayout="row" fxLayoutAlign="start center">
                <span>Bulk Image Upload </span>
              </div>
              <div
                class="products-padding"
                fxLayout="row"
                fxLayoutAlign="start center">
                <div>
                  <ng-container *ngIf="!zipStatus">
                    <calsoft-zip-import
                    [productId]="0"
                    [id]="0"
                      (onSuccess)="getResult($event)">
                    </calsoft-zip-import>
                  </ng-container>

                  <div
                    class="products-padding"
                    fxLayout="column"
                    *ngIf="zipStatus && zipFailedList?.length > 0"
                  >
                    <div fxLayout="row">Failure List:</div>
                    <div fxLayout="row">
                      <table fxFlex>
                        <tr>
                          <th>Name</th>
                        </tr>
                        <tr *ngFor="let item of zipFailedList">
                          <td>{{ item }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div
                    class="products-padding"
                    fxLayout="row"
                    *ngIf="zipStatus && (!zipFailedList || zipFailedList.length === 0)"
                  >
                  Bulk Image Upload Uploaded SuccessFully
                  </div>

                  <div
                    fxLayout="row"
                    fxLayoutAlign.gt-md="end center"
                    fxLayoutAlign.lt-md="start center"
                    fxLayoutGap="10px">

                  </div>

                </div>
              <!-- end -->

              <!-- end -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
